export function parseName(name) {
  return name
    .replace(/[^\wÀ-ÖØ-öø-ÿ'. &+@/%\-]/gi, '') 
    .replace(/\s+/g, ' ')
    .trimStart();
}

export function isValidName(name) {
  if (!name || name.length < 2 || name.length > 100)
    return false;

  return /^[\wÀ-ÖØ-öø-ÿ'. &+@/%\-]+$/i.test(name);
}

export function parseNames(names) {
  if (typeof names === 'string')
    names = names.split(',');
  return names.map(name => parseName(name));
}